//----Error Messages--//
export const MAKE_MODEL_ERR = "Please Fill Make & Model To Continue..";
export const VIN_ERR = "Must be 9-17 length with no special character";
export const YEAR_ERR = "Year should be greater than 1970";
export const EMAIL_ERR = "Please provide valid email";
export const AR_ACC_ERR = "AR Account should be 10 digits";
export const DC_ERR = "DC Code should be 3 in length";
export const NUMERIC_ERR="Numeric values are not allowed";
export const DATA_ERR='Please choose a value';
export const DATA_MISS='Please enter a value';
export const CHAR_ERR='Character values are not allowed';
export const NAPA_CODE_ERR = "NAPA Code should be 3 digits";
export const PART_ERR = "Please Enter atleast one: Our Part or Competitor Part";
export const LOGIN_FAILED_ERR = "Login Failed LogOut & Try Later...";
export const NO_ROLE_ERR = "Permission Denied,No Access to Application.";
export const COMPITATOR_NO_RECORDS = "No records available for this part.";
export const IMPORT_FAIL = "**Upload fail";
export const IMPORT_FAIL_504 =
  "Data is getting loaded , please check the loaded survey after sometime.";
export const NO_DATA = "No Data Available";
export const NO_FlEET_SELECTION = "Fleet Not Selected";
export const NO_SURVEY_SELECTION = "Survey Not Selected";
export const LOADING_FAILED = "Failed to load data";
export const ALERT_VIEW_WARNING_HEADER =
  "Some record have non-numeric value for Year field.";
export const ALERT_VIEW_WARNING =
  "Do you want to ignore those value & continue Import";
export const FALLBACK_TEXT = "Something went wrong";
//----//

//---Confirmation Messages --//
export const DELETE_STORE_CONFIRM_MSG =
  "Are you sure, Do you want to delete this store?";
export const STORE_NOT_SELECTED = "Store Not Selected";
//---

//---Success Messages --//
export const VEHICLE_SAVE_SUCCESS_MSG = "Vehicle saved successfully";
export const VEHICLE_UPDATE_SUCCESS_MSG = "Vehicle updated successfully";
export const STORE_UPDATE_SUCCESS_MSG = "Store Updated To Associated Survey";
export const PARTS_UPDATE_SUCCESS_MSG = "Part updated successfully";

//
export const SURVEY_SELECT_MASG = "Please select a survey";
export const VIN_ID_MSG ="Please select survey to add vehicle";
